import type {
  MomentsArtifactNote,
  MomentsReflectionStoredSourceIdentity,
} from '@/store/api/momentsApi';

// v1 reflection surfaces only place legacy-contract notes; a v2 identity
// (member-reflection-v2 artifacts only) reads there as "no usable identity".
export const legacyStoredSourceIdentity = (
  identity: MomentsArtifactNote['sourceIdentity'],
): MomentsReflectionStoredSourceIdentity | null | undefined => {
  if (identity === undefined || identity === null) return identity;
  return identity.readerContract === 'frontend-reflection-legacy-v1'
    ? identity
    : null;
};
